import type { ShiftChecklist } from "@apartos/contracts";
import { shiftChecklistItems } from "../lib/shiftChecklist";

export function ShiftChecklistFields({ value, onChange, mode, title, showExtra = true }: {
  value: ShiftChecklist;
  showExtra?: boolean;
  onChange: (value: ShiftChecklist) => void;
  mode: "accept" | "handover";
  title: string;
}) {
  const done = shiftChecklistItems.filter((item) => value[item.key]).length;
  return <fieldset className="shift-checklist">
    <legend><span>{title}</span><small>{done} из {shiftChecklistItems.length}</small></legend>
    {shiftChecklistItems.map((item) => <label key={item.key} className={`shift-checklist__item ${value[item.key] ? "is-done" : ""}`}>
      <input type="checkbox" checked={value[item.key]} onChange={(event) => onChange({ ...value, [item.key]: event.target.checked })}/>
      <span><strong>{item.label}</strong><small>{item[mode]}</small></span>
    </label>)}
    {showExtra && <label className="field shift-checklist__extra"><span>Дополнительно (если нужно что-то вписать)</span>
      <textarea maxLength={1000} rows={2} value={value.extraNotes ?? ""} onChange={(event) => onChange({ ...value, extraNotes: event.target.value })} placeholder={mode === "accept" ? "Например: в апт 7 не работает кондиционер" : "Например: гость из апт 3 просил поздний выезд"}/>
    </label>}
  </fieldset>;
}
